import { WeeklyProjectionPlayer } from "../model/WeeklyProjectionPlayer";

export const convertWeeklyProjection: (data: any[]) => WeeklyProjectionPlayer[] = (data: any) => {
    const result = [...data];
    result.shift();
    return result.map(e => {
        return {
            rank: Number(e[0]),
            name: e[1],
            perGameValue: Number(e[2]),
            team: e[3],
            pos: e[4],
            g: Number(e[5]),
            mpg: Number(e[6]),
            pts: Number(e[7]),
            threePtm: Number(e[8]),
            reb: Number(e[9]),
            ast: Number(e[10]),
            stl: Number(e[11]),
            blk: Number(e[12]),
            fgPercentage: Number(e[13]),
            fga: Number(e[14]),
            ftPercentage: Number(e[15]),
            fta: Number(e[16]),
            to: Number(e[17]),
            pVal: Number(e[18]),
            threeVal: Number(e[19]),
            rVal: Number(e[20]),
            aVal: Number(e[21]),
            sVal: Number(e[22]),
            bVal: Number(e[23]),
            fgPercenrageVal: Number(e[24]),
            ftPercentageVal: Number(e[25]),
            toVal: Number(e[26])
        } as WeeklyProjectionPlayer;
    })
}